module.exports = __webpack_public_path__ + "static/img/5.8f6b2db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Empresariales-Multirriesgo-Copropiedades/5.png
// module id = dOUo
// module chunks = 0